import { createAsyncThunk } from '@reduxjs/toolkit'
import Address from './address-model'
import { delete_address, load_addresss, store_address } from './address-service'

export const LoadAddresssAsync = createAsyncThunk<any, any>(
  'composer/load/address',
  async (params: { uid: string }) => {
    return await load_addresss(params)
  },
)

export const CreateAddressAsync = createAsyncThunk<any, any>(
  'composer/create/address',
  async (params: Address) => {
    return await store_address(params)
  },
)

export const DeleteAddressAsync = createAsyncThunk<any, any>(
  'composer/delete/address',
  async (params) => {
    return await delete_address(params)
  },
)
